<div class="ui-g-12" class="dmk-round-header">{{ 'TOURNAMENTS.QUALIFICATIONROUND' | translate }}&nbsp;{{ round.roundNum }}</div>
<div *ngIf="!ds.mobile && round.matches.length > 4" class="dmk-overall">
    <div class="dmk-container" style="padding-top: 1em;">
        <div *ngFor="let m of round.matches; let i = index" class="ui-g-12 text-center">
            <match *ngIf="i % 2 === 0" [match]="m" [round]="round"></match>
        </div>
    </div>
    <div class="dmk-container">
        <div *ngFor="let m of round.matches; let i = index" class="ui-g-12 text-center">
            <match *ngIf="i % 2 === 1" [match]="m" [round]="round"></match>
        </div>
    </div>
</div>
<div *ngIf="!ds.mobile && round.matches.length < 5">
    <div *ngFor="let m of round.matches" class="ui-g-12 text-center">
        <match [match]="m" [round]="round"></match>
    </div>
</div>
<div *ngIf="ds.mobile">
    <div *ngFor="let m of round.matches" class="dmk-match-container">
        <match [match]="m" [round]="round"></match>
    </div>
</div>